import { Component, OnInit } from '@angular/core';
import { Season, Localized } from '../../../../objects';
import { SeasonService } from '../../services/season.service';
import { MatDialogRef } from '@angular/material/dialog';
import { EditEntityBaseClass } from '../EditEntityBaseClass';

@Component({
  selector: 'app-season-edit',
  templateUrl: './season-edit.component.html',
  styleUrls: ['./season-edit.component.css']
})
export class SeasonEditComponent extends EditEntityBaseClass  implements OnInit {

  public item: Season;

// public lectionaryItemTypes: LectionaryItemType[];
// public religionBranches: ReligionBranchSummary[];

  constructor(
    private seasonSvc: SeasonService,
    private dialog: MatDialogRef<SeasonEditComponent>
  ) {
    super();
  }

  public LoadItem(itemId: number) {
    if (itemId) {
      this.seasonSvc.getItem(itemId).then(
        (data: Season) => {
          this.item = data;
          this.listsLoaded = true;
          console.log(data);

          if (this.item != null && this.item.Localized != null) {
            this.currentLocalizedData = this.item.Localized[0];
          }

        }
      )
    }
  }

  public cancel() {
    this.dialog.close();
  }

  public save() {
    console.log(this.item);

    this.seasonSvc.save(this.item).then(
      (data) => {
        console.log(data);
        this.dialog.close(data);
      }
    ).catch(
      (err) => {
        console.log("error", err);
      }
    )

  }

}

